"use client";
import Link from "next/link";
import DynamicImage from "../DynamicImages/DynamicImage";
import Image from "next/image";
import { allCategoryList } from "./arrayCategorylist";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useDispatch } from "react-redux";
import { AddNewBreadcrum } from "@/redux/slices/breadcrumSlice";

const TypeCard = ({ product, src, item, onClickHanddler }) => {
  // <div className={`flex   h-full ${item?.imageFlag ? " items-center " : "items-end"} ${item?.fullImage ? " w-full h-full  p-0 pb-[76%]" : " px-[10px]"}`}>
  return (
    <Link
      href={item?.slug}
      onClick={onClickHanddler}
      className={` overflow-hidden  rounded-[15px] flex flex-col w-full  items-center  justify-end ${
        item?.fullImage
          ? "pt-0 min-h-[222px] relative"
          : "pt-[27px] min-h-[302px]"
      } ${
        item?.bgGray
          ? "bg-[#F1F1F1F1] shadow-typeCardGrayBg"
          : "bg-[#fff] shadow-typeCardBg"
      } `}
    >
      <div
        className={`flex   h-full ${
          item?.imageFlag ? " items-center " : "items-end"
        } ${item?.fullImage ? " w-full h-full  p-0 pb-[76%]" : " px-[10px]"}`}
      >
        <Image
          src={src}
          className={`  ${
            item?.fullImage
              ? "object-cover absolute top-0 bottom-0 left-0 right-0 h-[calc(100%-55px)] w-full "
              : " h-auto  object-contain"
          }`}
          alt="type"
        />
      </div>
      <p
        className={`font-medium text-[14px] underline pt-[20px] pb-[18px] text-center ${
          item?.fullImage ? " bg-white w-full " : ""
        }`}
      >
        {product}
      </p>
    </Link>
  );
};

const Type = ({ categoryType }) => {
  const dispatch = useDispatch();
  const DataResponse = allCategoryList.find((item) => item[categoryType])?.[
    categoryType
  ];

  const listOptions = Array.isArray(DataResponse?.brandOptions)
    ? DataResponse.brandOptions
    : [];

  const updateBreadcrumb = (breadcrumb) => {
    dispatch(AddNewBreadcrum(breadcrumb));
  };

  return (
    <div className=" pt-[34px]  ">
      <Tabs defaultValue="account" className="w-full">
        <div className="w-full my-0 mx-auto max-w-[1690px] border-b-2 border-b-[#E4E9F5]">
          <div className=" max-w-[1428px] px-[15px] my-0 mx-auto">
            <TabsList className="h-[56px] p-0">
              <TabsTrigger
                className=" text-[19px] font-medium text-[#565E70] px-[15px] pt-[12px] pb-[15px] data-[state=active]:border-0 data-[state=active]:bg-[#001833] data-[state=active]:text-white rounded-t-[6px]"
                value="account"
              >
                Shop by Type
              </TabsTrigger>
            </TabsList>
          </div>
        </div>

        {categoryType === "AllLaundry" &&
          listOptions[0]?.type === "WasherDryer" && (
            <TabsContent value="account">
              <div className=" max-w-[1428px] my-0 mx-auto">
                <div className="px-[15px] my-3">
                  <div className=" flex justify-between gap-4 py-[10px] ">
                    <h1 className="text-[#000000] text-[30px] leading-[40px] font-semibold">
                      Washer & Dryers
                    </h1>
                  </div>
                </div>

                <div className=" grid grid-cols-223 gap-x-[13px] gap-y-[38px]  pb-[54px] px-[15px] my-0 mx-auto flex-wrap">
                  {listOptions.map((item, index) => (
                    <>
                      {item?.type === "WasherDryer" && (
                        <TypeCard
                          src={item?.img}
                          key={index}
                          product={item?.title}
                          item={item}
                          onClickHanddler={() => {
                            updateBreadcrumb([
                              {
                                name: 'Washer & Dryer',
                                url: '/laundry',
                              },
                              {
                                name: item?.title,
                                url: item.slug,
                              },
                            ]);
                          }}
                        />
                      )}
                    </>
                  ))}
                </div>
              </div>
            </TabsContent>
          )}
        {categoryType === "AllLaundry" &&
          listOptions[4]?.type === "Washers" && (
            <TabsContent value="account">
              <div className=" max-w-[1428px] my-0 mx-auto">
                <div className="px-[15px] mb-6">
                  <div className=" flex justify-between gap-4 py-[10px]  border-b border-[#E4E9F5] ">
                    <h1 className="text-[#000000] text-[30px] leading-[40px] font-semibold">
                      Washers
                    </h1>
                    <Link
                      href="/laundry/washers"
                      className="text-[#0B223C] text-[16px] leading-[24px] font-semibold p-[10px_20px] border border-[#0B223C] rounded-[8px] "
                      onClickHanddler={() => {
                        updateBreadcrumb([
                          {
                            name: 'Washers',
                            url: '/laundry/washers',
                          }
                        ]);
                      }}
                    >
                      Shop All
                    </Link>
                  </div>
                </div>
                <div className=" grid grid-cols-193 gap-x-[13px] gap-y-[38px]  pb-[54px]  px-[15px] my-0 mx-auto flex-wrap">
                  {listOptions.map((item, index) => (
                    <>
                      {item?.type === "Washers" && (
                        <TypeCard
                          src={item?.img}
                          key={index}
                          product={item?.title}
                          item={item}
                          onClickHanddler={() => {
                            updateBreadcrumb([
                              {
                                name: 'Washers',
                                url: '/laundry/washers',
                              },
                              {
                                name: item?.title,
                                url: item.slug,
                              },
                            ]);
                          }}
                        />
                      )}
                    </>
                  ))}
                </div>
              </div>
            </TabsContent>
          )}

        {categoryType === "AllLaundry" && listOptions[7]?.type === "Dryers" && (
          <TabsContent value="account">
            <div className=" max-w-[1428px] my-0 mx-auto">
              <div className="px-[15px] mb-6">
                <div className=" flex justify-between gap-4 py-[10px]  border-b border-[#E4E9F5] ">
                  <h1 className="text-[#000000] text-[30px] leading-[40px] font-semibold">
                    Dryers
                  </h1>

                  <Link
                    href="/laundry/dryers"
                    className="text-[#0B223C] text-[16px] leading-[24px] font-semibold p-[10px_20px] border border-[#0B223C] rounded-[8px] "
                    onClickHanddler={() => {
                      updateBreadcrumb([
                        {
                          name: 'Dryers',
                          url: '/laundry/dryers',
                        }
                      ]);
                    }}
                  >
                    Shop All
                  </Link>
                </div>
              </div>
              <div className=" grid grid-cols-193 gap-x-[13px] gap-y-[38px]  pb-[54px] max-w-[1428px] px-[15px] my-0 mx-auto flex-wrap">
                {listOptions.map((item, index) => (
                  <>
                    {item?.type === "Dryers" && (
                      <TypeCard
                        src={item?.img}
                        key={index}
                        product={item?.title}
                        item={item}
                        onClickHanddler={() => {
                          updateBreadcrumb([
                            {
                              name: 'Dryers',
                              url: '/laundry/dryers',
                            },
                            {
                              name: item?.title,
                              url: item.slug,
                            },
                          ]);
                        }}
                      />
                    )}
                  </>
                ))}
              </div>
            </div>
          </TabsContent>
        )}

        {categoryType !== "AllLaundry" && (
          <TabsContent value="account">
            {/* <div className={` ${listOptions[0]?.fullImage ? "flex justify-between py-[54px] " : "grid pt-[10px] pb-[34px]" }  grid-cols-204 gap-x-[13px] gap-y-[38px]  my-0 mx-auto `}> */}
            <div className=" grid grid-cols-193 gap-x-[13px] gap-y-[38px] pt-[50px] pb-[34px] max-w-[1428px] px-[15px] my-0 mx-auto flex-wrap lg:gap-[15px_12px]">
              <>
                {listOptions.map((item, index) => (
                  <TypeCard
                    src={item?.img}
                    key={index}
                    product={item?.title}
                    item={item}
                    onClickHanddler={() => {
                      updateBreadcrumb([
                        {
                          name: DataResponse?.title,
                          url: DataResponse?.shopAll,
                        },
                        {
                          name: item?.title,
                          url: item.slug,
                        },
                      ]);
                    }}
                  />
                ))}
                <Link
                  href={DataResponse?.shopAll}
                  className="shadow-[1.96px_3.92px_11.76px_0px_#00000014] min-h-[310px] lg:text-[25px] rounded-[15px] bg-[#D3DBE2] text-[#0B223C] text-[32px] font-bold flex items-center justify-center cursor-pointer"
                  onClick={() =>
                    updateBreadcrumb([
                      {
                        name: DataResponse?.title,
                        url: DataResponse?.shopAll,
                      },
                    ])
                  }
                >
                  Shop All
                </Link>
              </>
            </div>
          </TabsContent>
        )}
        <TabsContent value="password">Change your password here.</TabsContent>
      </Tabs>
    </div>
  );
};

export default Type;
